import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage, StatCard, StateBadge } from "@/components/admin/AdminUI";
import { Button } from "@/components/ui/button";

const ACTION_LABEL = (a) => (a || "").replace(/_/g, " ");

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);
  if (!stats) return <div className="p-8 text-slate-400 animate-pulse">Loading dashboard…</div>;

  return (
    <>
      <AdminHeader title="Dashboard" subtitle="Institutional overview" actions={
        <Button asChild className="bg-npst-navy hover:bg-npst-navyDeep text-white"><Link to="/admin/pils/new" data-testid="dashboard-add-pil"><Plus size={16} className="mr-1.5" /> Add PIL</Link></Button>
      } />
      <AdminPage>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <StatCard label="Total PILs" value={stats.total_pils} />
          <StatCard label="Pending PILs" value={stats.pending_pils} accent="text-blue-700" />
          <StatCard label="Disposed / Decided" value={stats.disposed_pils} accent="text-emerald-700" />
          <StatCard label="Court Orders" value={stats.total_orders} />
          <StatCard label="Documents" value={stats.total_documents} />
          <StatCard label="Press Releases" value={stats.press_releases} />
          <StatCard label="Draft Releases" value={stats.draft_releases} accent="text-amber-700" />
          <StatCard label="New Enquiries" value={stats.new_enquiries} accent="text-blue-700" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white border border-slate-200 rounded-lg p-6">
            <div className="label-eyebrow text-npst-gold mb-4">Recent PIL Updates</div>
            {stats.recent_pils?.length ? stats.recent_pils.map((p) => (
              <Link key={p.id} to={`/admin/pils/${p.id}`} className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-0 hover:text-npst-navy">
                <span className="text-sm text-npst-ink truncate pr-4">{p.title}</span>
                <StateBadge state={p.state} />
              </Link>
            )) : <p className="text-sm text-slate-400">No PILs yet.</p>}
          </div>
          <div className="bg-white border border-slate-200 rounded-lg p-6">
            <div className="label-eyebrow text-npst-gold mb-4">Recent Admin Activity</div>
            {stats.recent_activity?.length ? stats.recent_activity.map((a) => (
              <div key={a.id} className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-0 text-sm">
                <span className="text-npst-ink"><span className="font-medium">{ACTION_LABEL(a.action)}</span> <span className="text-slate-400">by {a.user_name}</span></span>
                <span className="text-xs text-slate-400 font-mono">{a.created_at?.slice(0, 10)}</span>
              </div>
            )) : <p className="text-sm text-slate-400">No activity yet.</p>}
          </div>
        </div>
      </AdminPage>
    </>
  );
}
